import { faCartShopping } from '@fortawesome/free-solid-svg-icons';
import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import StatsItem from '../../home/StatsItem';

class Stats extends Component {
	render() {
		const { loading, data, className, year, t } = this.props;
		const { lessonPaymentCount, lessonPaymentAmount, lessonPaymentAverage, lessonPaymentDiscount } = data || { lessonPaymentCount: null, lessonPaymentAmount: null, lessonPaymentAverage: null, lessonPaymentDiscount: null };

		const comparisonLabel = year ? t('SalesDashboard_SincePreviousYear') : t('SalesDashboard_SincePreviousPeriod');

		return <Row className={className}>
			<Col md={3} sm={6}>
				<StatsItem
					colorClassName='bg-green'
					label={t('Stats_LessonPaymentsCount')}
					icon={faCartShopping}
					comparisonLabel={comparisonLabel}
					loading={loading}
					{...lessonPaymentCount}
				/>
			</Col>
		</Row>;
		/*<Col md={3} sm={6}>
				<StatsItem
					colorClassName='bg-primary'
					label={t('Stats_LessonPaymentsAmount')}
					iconClassName='fa fa-dollar'
					comparisonLabel={comparisonLabel}
					loading={loading}
					{...lessonPaymentAmount}
				/>
			</Col>
			<Col md={3} sm={6}>
				<StatsItem
					colorClassName='bg-danger'
					label={t('Stats_AverageLessonPayments')}
					iconClassName='fa fa-bar-chart-o'
					comparisonLabel={comparisonLabel}
					loading={loading}
					{...lessonPaymentAverage}
				/>
			</Col>
			<Col md={3} sm={6}>
				<StatsItem
					colorClassName='bg-info'
					label={t('Stats_LessonPaymentsDiscount')}
					iconClassName='fa fa-gift'
					comparisonLabel={comparisonLabel}
					loading={loading}
					{...lessonPaymentDiscount}
				/>
			</Col>*/
	}
}

export default withTranslation()(Stats);